import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { GlobalService } from "./global.service";
import { map, debounceTime, tap } from "rxjs/operators";
import { Authdata } from "../classes/authdata.class";
import { BsrmencryptionService } from "./bsrmencryption.service";

@Injectable()
export class BsrmhttpService {
  constructor(
    private httpClient: HttpClient,
    private globalServices: GlobalService,
    private crypto: BsrmencryptionService
  ) {}
  prepareHttpOption(prms) {
    // var authData  = new Authdata().getData();
    // var contentType = 'application/json';
    // var myToken = authData ? authData.token_type+' '+authData.access_token : '';
    // var rspId = authData ?
    //             sessionStorage.getItem(this.globalServices.selectedResponsibilityKey).toString()
    //             : '';

    // var httpHeaders = new HttpHeaders({
    //   'Content-Type':  contentType,
    //   'Authorization': myToken ,
    //   'RSPID' :   rspId,
    //   'Accept' : 'q=0.8;application/json;q=0.9'
    // })

    if (prms) {
      return {
        // headers : httpHeaders,
        params: prms,
      };
    } else {
      return {
        // headers : httpHeaders
      };
    }
  }

  prepareHttpOptionParamAsBody(params) {
    // var authData  = new Authdata().getData();
    // var contentType = 'application/json';
    // var myToken = authData ? authData.token_type+' '+authData.access_token : '';
    // var rspId = authData ?
    //             sessionStorage.getItem(this.globalServices.selectedResponsibilityKey).toString()
    //             : '';

    // var httpHeaders = new HttpHeaders({
    //   'Content-Type':  contentType,
    //   'Authorization': myToken ,
    //   'RSPID' :   rspId,
    //   'Accept' : 'q=0.8;application/json;q=0.9'
    // })

    if (params) {
      return {
        // headers : httpHeaders,
        body: params,
      };
    } else {
      return {
        // headers : httpHeaders
      };
    }
  }
  prepareHttpOptionWithBody(params, httpBody) {
    // var authData  = new Authdata().getData();
    // var contentType = 'application/json';
    // var myToken = authData ? authData.token_type+' '+authData.access_token : '';
    // var rspId = authData ?
    //             sessionStorage.getItem(this.globalServices.selectedResponsibilityKey).toString()
    //             : '';

    // var httpHeaders = new HttpHeaders({
    //   'Content-Type':  contentType,
    //   'Authorization': myToken ,
    //   'RSPID' :   rspId,
    //   'Accept' : 'q=0.8;application/json;q=0.9'
    // })

    if (params) {
      return {
        // headers : httpHeaders,
        params: params,
        body: httpBody,
      };
    } else {
      return {
        // headers : httpHeaders
        // body : httpBody
      };
    }
  }
  prepareTokenHttpOption() {
    // var contentType = 'application/x-www-form-urlencoded';
    // var httpHeaders = new HttpHeaders({
    //   'Content-Type':  contentType,
    // })

    return {
      // headers : httpHeaders,
    };
  }

  public get(api: string, params: any = null) {
    // this.globalServices.showProgressbar();
    var apiUrl = this.globalServices.getApiUrl() + api;
    // console.log("api url in get");
    // console.log(apiUrl);
    // console.log("param");
    // console.log(params);
    return this.httpClient.get(apiUrl, this.prepareHttpOption(params));
  }
  public post(api: string, params: any, paramAsBody: boolean = false) {
    // console.log('api '+api);
    // console.log('values '+JSON.stringify(values));
    //console.log('api details '+this.globalServices.getApiUrl()+api);
    // ;
    try {
      // this.globalServices.showProgressbar();
      let body = JSON.parse(JSON.stringify(params));
      //var options = paramAsBody == false ? this.prepareHttpOption(params) : this.prepareHttpOptionParamAsBody(params);
      var options = this.prepareHttpOptionParamAsBody(params);
      return this.httpClient.post(this.globalServices.getApiUrl() + api, body);
      // return this.httpClient.post(this.globalServices.getApiUrl()+api, body);
    } catch (ex) {
      return null;
    }
  }
  public put(api: string, params: any, paramAsBody: boolean = false) {
    // console.log('api '+api);
    // console.log('values '+JSON.stringify(values));
    //console.log('api details '+this.globalServices.getApiUrl()+api);
    try {
      // this.globalServices.showProgressbar();
      let body = JSON.parse(JSON.stringify(params));
      var options =
        paramAsBody == false
          ? this.prepareHttpOption(params)
          : this.prepareHttpOptionParamAsBody(params);
      return this.httpClient.put(
        this.globalServices.getApiUrl() + api,
        body,
        this.prepareHttpOption(params)
      );
    } catch (ex) {
      return null;
    }
  }
  public delete(api: string, params: any) {
    // console.log('api '+api);
    // console.log('values '+JSON.stringify(values));
    //console.log('api details '+this.globalServices.getApiUrl()+api);
    try {
      // this.globalServices.showProgressbar();
      let body = JSON.parse(JSON.stringify(params));
      return this.httpClient.delete(
        this.globalServices.getApiUrl() + api,
        this.prepareHttpOptionWithBody(params, body)
      );
    } catch (ex) {
      return null;
    }
  }
  public findKey(userName: string, userPassword: string): any {
    var params: string =
      "username=" +
      userName +
      "&password=" +
      userPassword +
      "&grant_type=password";

    // this.globalServices.showProgressbar();
    // console.log('token url');
    // console.log(this.globalServices.getTokenUrl());
    return this.httpClient.post(
      this.globalServices.getTokenUrl(),
      params,
      this.prepareTokenHttpOption()
    );
  }
}
